import { useDispatch, useState, useGlobal } from "reactn";

import { useUpdateUserInfo } from "state/users/hooks";
import { useAuth } from "./useAuth";
import { validate } from "lib/rut";

export const useTemporaryUser = (
	closeModal,
	getReserve,
	hourBlock,
	handleMeet
) => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [update] = useUpdateUserInfo();
	const { isLoggedInTemporary, isLoggedIn } = useAuth();
	const doTemporaryLogin = useDispatch("doTemporaryLogin");
	const doUpdateTemporaryUser = useDispatch("doUpdateTemporaryUser");
	const [user] = useGlobal("user");
	const [forms] = useGlobal("forms");

	const logIn = async (payload, token, meta, pickTicket) => {
		if (isLoggedInTemporary) {
			const { rut, name, email, phone, dni } = payload;

			if (dni && dni.length && !Number(dni)) {
				setLoading(false);
				return setError({
					message: "Error verifique su DNI",
				});
			}

			const obj = {
				token: user.token,
				rut,
				name,
				email,
				phone,
				dni,
			};

			setLoading(true);
			doUpdateTemporaryUser(obj)
				.then(() => {
					setSuccess(true);
					setLoading(false);
					if (pickTicket) {
						pickTicket();
						return;
					}
					if (getReserve) {
						getReserve(hourBlock, handleMeet(), meta);
						return false;
					}
				})
				.catch((debug) => {
					setLoading(false);
					setError({
						message: "Error al actualizar usuario temporal",
						debug,
					});
				});
			return;
		}

		if (isLoggedIn) {
			// const dni = payload && payload.dni && payload.dni;
			const { rut, phone, code, dni } = payload;

			const obj = {
				dni,
				rut,
				phone: phone && code ? code + phone : phone,
			};
			setLoading(true);
			update(obj)
				.then(() => {
					setSuccess(true);
					setLoading(false);
					closeModal();

					if (pickTicket) {
						pickTicket();
						return;
					}
					if (getReserve) {
						getReserve(hourBlock, handleMeet(), meta);
						return false;
					}
				})
				.catch((debug) => {
					setLoading(false);
					setError({
						message: "Error al actualizar usuario ",
						debug,
					});
				});
			return;
		}

		const { rut, name, email, phone, dni, sessionId } = payload;

		if (dni && dni.length && !Number(dni)) {
			setLoading(false);
			return setError({
				message: "Error verifique su DNI",
			});
		}

		const obj = { sessionId, rut, name, email, phone, dni };
		const validRUT = validate(rut);

		if (rut && rut.length && !validRUT) {
			setLoading(false);
			return setError({
				message: "Error verifique su RUT",
			});
		}
		setLoading(true);
		doTemporaryLogin(obj, token)
			.then(() => {
				setSuccess(true);
				setLoading(false);
				if (pickTicket) {
					pickTicket();
					return;
				}
				if (getReserve) {
					getReserve(hourBlock, handleMeet(), meta);
					return false;
				}
			})
			.catch((debug) => {
				setLoading(false);

				setError({
					message:
						"Ocurrio un error inesperado por favor recargue la pagina e intente nuevamente",
					debug,
				});
			});
	};

	return [logIn, success, loading, error];
};
